"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roleFields = exports.verticalTabTopPadding = exports.verticalTabWidth = exports.commaSeperator = exports.fieldWidth = exports.key = exports.datePickerWidth = exports.datePickerHeight = exports.approverTypeList = exports.approversData = exports.notificationMediumData = exports.isDateTimeData = exports.isIPAddressData = exports.SAVE_AND_ENABLE = exports.classes = void 0;

var _externalization = require("../../../../packages/policy-management/externalization");

var classes = {
  addPolicyWrapper: 'add-policy-wrapper',
  formNameLoaderWrapper: 'form-name-loader-wrapper',
  readOnlyConsumer: 'read-only-consumer',
  addPolicyFieldWrapper: 'add-policy-field-wrapper',
  addPolicyFieldValueWrapper: 'add-policy-field-value-wrapper',
  addPermissionButtonsWrapper: 'add-permission-buttons-wrapper',
  addPermissionButtonWrapper: 'add-permission-button-wrapper',
  verticalTabWrap: 'vertical-tab-wrap'
};
exports.classes = classes;
var SAVE_AND_ENABLE = 'SAVE_AND_ENABLE';
exports.SAVE_AND_ENABLE = SAVE_AND_ENABLE;
var isIPAddressData = [{
  label: 'Yes',
  value: 'true'
}, {
  label: 'No',
  value: 'false'
}];
exports.isIPAddressData = isIPAddressData;
var isDateTimeData = [{
  label: 'Yes',
  value: 'true'
}, {
  label: 'No',
  value: 'false'
}];
exports.isDateTimeData = isDateTimeData;
var notificationMediumData = [{
  label: 'Slack',
  value: 'slack'
}, {
  label: 'email',
  value: 'email'
}];
exports.notificationMediumData = notificationMediumData;
var approversData = [{
  label: 'Yes',
  value: 'true'
}, {
  label: 'No',
  value: 'false'
}];
exports.approversData = approversData;
var approverTypeList = [{
  label: 'Users',
  value: 'users'
}, {
  label: 'Tags',
  value: 'tags'
}, {
  label: 'Channels',
  value: 'channels'
}];
exports.approverTypeList = approverTypeList;
var datePickerHeight = '40px';
exports.datePickerHeight = datePickerHeight;
var datePickerWidth = '512px';
exports.datePickerWidth = datePickerWidth;
var key = 'key';
exports.key = key;
var fieldWidth = '512px';
exports.fieldWidth = fieldWidth;
var commaSeperator = ',';
exports.commaSeperator = commaSeperator;
var verticalTabWidth = '288px';
exports.verticalTabWidth = verticalTabWidth;
var verticalTabTopPadding = '48px';
exports.verticalTabTopPadding = verticalTabTopPadding;
var roleFields = [{
  key: 'consumer',
  label: (0, _externalization.translate)('CONSUMER')
}, {
  key: 'resources',
  label: (0, _externalization.translate)('RESOURCES')
}, {
  key: 'actions',
  label: (0, _externalization.translate)('ROLES_MODULE.ACTIONS')
}];
exports.roleFields = roleFields;